import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import PropertyDetail from "@/pages/PropertyDetail";
import Experiences from "@/pages/Experiences";
import HostDashboard from "@/pages/HostDashboard";
import Trips from "@/pages/Trips";
import Messages from "@/pages/Messages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/proprietate/:id" element={<PropertyDetail />} />
      <Route path="/experiente" element={<Experiences />} />
      <Route path="/gazda" element={<ProtectedRoute requireHost><HostDashboard /></ProtectedRoute>} />
      <Route path="/calatorii" element={<ProtectedRoute><Trips /></ProtectedRoute>} />
      <Route path="/mesaje" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
